import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import BannerStyleDownloadButton from '../BannerStyleDownloadButton';

import useCreateBlob from '../../app/components/TestResultsDocuments/useCreateBlob.hook';

import {
  downloadTreatmentPrescription,
  clearDownloadTreatmentPrescription,
} from '../../app/actions/treatmentPage';

export interface TreatmentStepDownloadButtonProps {
  fileName: string;
  stepId?: string;
  backgroundColor?: string;
  textColor?: string;
  imageUrl?: string;
  imageAlt?: string;
  iconRight?: React.ReactNode;
  title: string;
  subtitle?: string;
  subtitleColor?: string;
  className: string;
  dispatch?: any;
  data?: any;
  error?: boolean;
}

const TreatmentStepDownloadButton: React.FC<
  TreatmentStepDownloadButtonProps
> = ({
  dispatch,
  data,
  fileName,
  error,
  stepId,
  backgroundColor,
  textColor,
  imageUrl,
  imageAlt,
  iconRight,
  title,
  subtitle,
  subtitleColor,
  className,
}) => {
  const { treatmentId } = useParams();
  const { downloadDocument, downloadError } = useCreateBlob(
    data?.blob,
    fileName,
    () => dispatch(clearDownloadTreatmentPrescription()),
  );

  const downloadPrescription = (prescription: string) => {
    dispatch(downloadTreatmentPrescription(prescription, treatmentId, stepId));
  };

  useEffect(() => {
    if (data && data.stepId === stepId) {
      downloadDocument();
    }
  }, [data, stepId, downloadDocument]);

  return (
    <BannerStyleDownloadButton
      backgroundColor={backgroundColor}
      textColor={textColor}
      imageUrl={imageUrl}
      imageAlt={imageAlt}
      iconRight={iconRight}
      title={title}
      subtitle={subtitle}
      subtitleColor={subtitleColor}
      onClick={() => downloadPrescription(fileName)}
      error={error || downloadError}
      className={className}
    />
  );
};

const mapStateToProps = (state: any) => ({
  data: state.treatmentPage.get('downloadTreatmentPrescriptionData'),
  error: state.treatmentPage.get('downloadTreatmentPrescriptionError'),
});

export default connect(mapStateToProps)(TreatmentStepDownloadButton);
